module.exports = __webpack_public_path__ + "img/av191.de956d73.png";